/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import appConfig from '../stores/config';
import { LEFT_NAV_KEYS, ANALYTICS } from '../utils/enums';

export default function sendAnalytics({
    subtype, sidenav, value, link, count, guid,
}) {
    let heading;
    if (!sidenav) {
        switch (subtype) {
        case LEFT_NAV_KEYS.ALL_APPS_KEY:
        case LEFT_NAV_KEYS.UPDATES_KEY:
            heading = 'Apps';
            break;
        case LEFT_NAV_KEYS.FONTS_PANEL_SECTION_GROUP_KEY:
            heading = 'Fonts';
            break;
        default:
            heading = 'Categories';
        }
    }
    const leftNavItemId = ANALYTICS.LEFT_NAV_SUBTYPE[subtype]
		    ? ANALYTICS.LEFT_NAV_SUBTYPE[subtype] : subtype;
    const obj = {};
    obj.event = {
        workflow: 'Apps',
        type: 'click',
        subcategory: 'Apps',
        subtype: leftNavItemId,
        value,
        count,
        guid,
    };
    obj.content = {
        category: sidenav || heading,
        action: link,
    };
    const componentParams = {
        source: ANALYTICS.APPS,
        sectionId: subtype,
        surfaceType: ANALYTICS.SURFACE_TYPE.SKELETON,
    };
    appConfig.analyticsCallback({ analyticObjectList: [obj], componentParams });
}
